import styled, { css, keyframes } from 'styled-components';


export const Header = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 8px;
    display: flex;
    flex-diretion: row;
    gap: 16px;
    justify-content: space-between;
    padding: 24px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      flex-direction: column;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `}
`;

export const Column = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    min-width: 368px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 100%;
      min-width: unset;
      width: 100%;
    }
  `}
`;

export const PlanNameSeparator = styled.span`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    height: 1.5px;
    justify-content: center;
    width: 8px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: none;
    }
  `}
`;

export const CloudFlareCdnExplanation = styled.span`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 8px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 8px 0px 0px;

    svg {
      flex: 0 0 24px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
    }
  `}
`;

export const ExplanationWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  `}
`;

export const RightColumn = styled(Column)`
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.lg}) {
    flex-direction: row;
    align-items: end;
  };

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    flex-direction: column;
  };
`;

export const InputWrapper = styled.div`
  align-self: start;
  max-width: 368px;
  width: 100%;
`;

export const HostingLabel = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowMedium};
    margin: 0px;
  `}
`;

export const ChangePlanWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap:  8px;
    justify-content: flex-start;
    margin: 16px 0px 0px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
      flex-direction: column;
      justify-content: flex-start;
      margin: 0px;
    }
  `}
`;

export const PlanNameRightBlock = styled.span`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      button {
        align-items: flex-end;
        padding: 0px;
      }
    }
  `}
`;

export const PlanName = styled.span`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
      flex-direction: column;
      justify-content: flex-start;
      margin: 16px 0px 0px 32px;
    }
  `}
`;

export const MainDomain = styled.span`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: flex-start;
      flex-direction: column;
      justify-content: flex-start;
      margin: 0px 0px 0px 32px;
    }
  `}
`;

export const RefreshButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 16px;
`;

const loadingLoop = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const IconRefreshContainer = styled.div`
  ${({ loading }) => css`
    align-items: center;
    display: flex;
    justify-content: center;

    ${loading && css`animation: ${loadingLoop} 0.5s linear infinite`};
  `};
`;
